import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";


const ShareIcon = ({ activityId, isBig }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyUrl = async () => {
        const currentUrl = window.location.origin + location.pathname + location.search;
        try {
            await navigator.clipboard.writeText(currentUrl);
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 2000)
        } catch (error) {
            console.error('Errore nella copia:', error);
            fallbackCopyTextToClipboard(currentUrl);
        }
    }

    // Fallback per browser che non supportano navigator.clipboard
    const fallbackCopyTextToClipboard = (text) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (error) {
            console.error('Fallback: Errore nella copia', error);
        }

        document.body.removeChild(textArea);
    };
    return (
        <div className={`
            rounded-full
            ${isBig ?
                'w-12 h-12 text-xl border border-[#225424]' :
                'w-12 h-12 md:w-6 md:h-6 text-xl md:text-xs'}
            bg-white text-[#b05704] flex justify-center items-center
            pt-[5px] cursor-pointer md:hover:scale-110
            transform transition-transform duration-300 relative
            `} onClick={handleCopyUrl}>
            {
                activityId &&
                <div>
                    <i className="fi fi-rs-share pr-0.5"></i>
                </div>
            }
            {
                isCopied &&
                <div className="
                        z-50 bg-red-500
                        border border-[#225424] rounded-md
                        absolute bottom-14 right-[-50px] text-black
                        w-[160px] text-xs p-2 bg-white
                        ">
                    {t('ActivityDetails.linkCopied')}
                </div>
            }
        </div>
    )
}

export default ShareIcon;